import { getDomainConfig, getLocale } from '@raisin/cp-utils';
export const frMenus = (logoUrl) => {
    const basePath = getDomainConfig(getLocale('fr-FR').cmsFormat).basePath;
    return {
        type: 'public',
        logoItems: [
            {
                id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
                href: `${basePath}/`,
                url: logoUrl,
                alt: 'Raisin',
            },
        ],
        navItems: [
            {
                id: '7c70fbcc-4e00-4fe1-8b47-87251d3534b5',
                title: 'Les offres',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'fixedDeposit-offers',
                            type: 'advanced',
                            title: 'Comptes à terme',
                            href: `${basePath}/compte-a-terme/`,
                            description: "Placement à durée déterminée et à un taux d'intérêt fixe",
                            icon: 'fixedDepositIcon',
                            iconColor: '#61AFD2',
                        },
                        {
                            id: 'overnightDeposit-offers',
                            type: 'advanced',
                            title: "Livrets d'épargne",
                            href: `${basePath}/livret-epargne/`,
                            description: "Placement flexible à durée indéterminée et à un taux d'intérêt variable",
                            icon: 'overnightMoneyIcon',
                            iconColor: '#9CD3E4',
                        },
                    ],
                },
            },
            {
                id: '36e9994f-8c35-4d1c-a470-fab6ad144699',
                title: 'À propos de Raisin',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'd71e82d5-84ea-4457-8cfc-762927bd8f21',
                            type: 'advanced',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltf266390c18780027/Sparen.svg',
                            iconColor: '#0E6CC5',
                            title: 'Comment investir',
                            href: `${basePath}/comment-investir/`,
                        },
                        {
                            id: '4a17825e-a704-457c-945f-f1b45c50b29e',
                            type: 'advanced',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt017f3eb0e4c93396/Bancos.svg',
                            iconColor: '#0E6CC5',
                            title: 'Banques partenaires',
                            href: `${basePath}/banque/`,
                        },
                        {
                            id: '8ec5d1d0-2452-4cad-acce-f8875f8b8277',
                            type: 'advanced',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt8a5863614d18d6bc/Zo_werkt_het.svg',
                            iconColor: '#0E6CC5',
                            title: 'Qui sommes-nous ?',
                            href: `${basePath}/a-propos/`,
                        },
                    ],
                },
            },
            {
                id: 'f149e12f-3a9f-44e3-a75e-ae1a37e12c64',
                title: 'En savoir plus',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'savings-finance',
                            type: 'advanced',
                            title: "Guide de l'épargne",
                            description: 'Un guide intégral pour vous aider à mieux gérer votre épargne',
                            href: `${basePath}/epargne/`,
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltf0001a4dd44c52d4/Guide_de_l_Épargne.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: 'investments-finance',
                            type: 'advanced',
                            title: 'Garantie des dépôts',
                            description: 'Comprendre le système de garantie des dépôts au sein de l’Union Européenne',
                            href: `${basePath}/garantie-des-depots/`,
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltec92767c887b11af/Garantie_des_dépôts.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: 'pension-finance',
                            type: 'advanced',
                            title: 'Fiscalité',
                            description: 'Comment vos placements auprès de nos différentes banques partenaires sont-ils imposés',
                            href: `${basePath}/fiscalite/`,
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt21cf5223c1caa2fe/Fiscalité.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: 'd63e6408-738b-4d6f-927a-bc2274804d68',
                            type: 'advanced',
                            title: 'Parrainer un ami',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt1d2b4737bfccdf07/Parrainer_un_ami.svg',
                            iconColor: '#0E6CC5',
                            description: "Recevez jusqu'à 500 EUR en recommandant Raisin à vos amis",
                            href: `${basePath}/parrainez-un-ami/`,
                        },
                    ],
                    sidebar: [
                        {
                            id: '682a68af-d0c3-4f6f-8aa4-0b4752040b0e',
                            type: 'image',
                            title: 'Épargner en France',
                            href: `${basePath}/epargne/epargne-en-france/`,
                            imageUrl: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt2583321398710b00/Image_Ausland.png',
                            description: 'Épargner en France',
                        },
                        {
                            id: 'f10ea65e-7827-42c9-a681-c0b214aeb11d',
                            type: 'arrow',
                            title: 'Placements sans risques ?',
                            href: `${basePath}/epargne/investissements-garantis/`,
                        },
                        {
                            id: '94216326-d1cb-4afe-9e1e-543421f52d57',
                            type: 'arrow',
                            title: 'Quelles alternatives au livret A ?',
                            href: `${basePath}/epargne/livret-a/alternatives/`,
                        },
                    ],
                },
            },
            {
                id: '2e11a01f-4216-4fea-b05f-2fd46cf3a8b4',
                title: 'Aide',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'a9cbf2ad-81bc-4f83-8196-b67b414f9b0f',
                            type: 'text',
                            title: 'Questions fréquentes',
                            href: 'https://assistance.raisin.com/hc/fr',
                        },
                        {
                            id: '9a91930e-db2a-45be-8eab-30a081e40e03',
                            type: 'text',
                            title: 'Contact',
                            href: `${basePath}/contactez-nous/`,
                        },
                    ],
                },
            },
        ],
        actionItems: [
            {
                id: '659be2f1-cdfa-4666-bcbb-edf874ad83ce',
                title: 'Mon Compte',
                href: `${basePath}/login/`,
                type: 'login',
            },
            {
                id: 'fc1573f6-a151-4299-aaef-0e1b375227ba',
                title: 'Inscription',
                href: `${basePath}/register/`,
                type: 'registration',
            },
        ],
    };
};
//# sourceMappingURL=frMenus.js.map